import React from "react";
import { Image } from "semantic-ui-react";

type Props = {
  mainSrc: string;
  fallbackSrc?: string;
  isRX?: boolean;
  className?: string;
};

// const DEFAULT_RX_IMAGE = "https://services.site.se/images/logo-rx.png";

const ImageWithFallback = ({
  mainSrc,
  fallbackSrc = "/images/Image-not-found.png",
  className,
}: Props) => {
  return (
    <Image
      src={mainSrc}
      onError={(e: any, t: any) => (e.currentTarget.src = fallbackSrc)}
      className={className}
    />
  );
};

export default ImageWithFallback;
